import Helper from './Helper';

class ColumnChart {
  constructor(chartMaxHeight) {
    const wrapperSelector = '.ns-chart-boxes';
    const blueSelector = '.ns-box--blue';
    const graySelector = '.ns-box--gray';
    const boxSelector = '.ns-chart-box__box';
    const valSelector = '.ns-chart-box__val';
    const wrapper = [...document.querySelectorAll(wrapperSelector)];
    wrapper.forEach(wrap => {
      const gray = wrap.querySelector(graySelector);
      const blue = wrap.querySelector(blueSelector);
      const grayTxt = gray.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const blueTxt = blue.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const numGray = parseFloat(grayTxt);
      const numBlue = parseFloat(blueTxt);
      const boxGray = gray.querySelector(boxSelector);
      const boxBlue = blue.querySelector(boxSelector);
      let grayHeight = chartMaxHeight;
      let blueHeight = chartMaxHeight;
      if (numGray < numBlue) {
        grayHeight = numGray / numBlue * chartMaxHeight;
      } else {
        blueHeight = numBlue / numGray * chartMaxHeight;
      }
      boxGray.style.height = grayHeight + 'px';
      boxBlue.style.height = blueHeight + 'px';
      wrap.classList.add("null");
      if (Helper.isInViewport(wrap)) {
        wrap.classList.remove("null");
        wrap.classList.add("draw");
      }
    });

    window.addEventListener('scroll', function (event) {
      wrapper.forEach(element => {
        if (Helper.isInViewport(element)) {
          element.classList.remove("null");
          element.classList.add("draw");
        }
      });
    }, false);

  }
}

export default ColumnChart;
